import React from 'react';

const Buttons = ({ btnLabel, className ,onClick}) => {
  return (
    <>
      <button className={className} onClick={onClick}>{btnLabel}</button>
    </>
  );
};

export default Buttons;
